
<template>
  <v-app id="onWatp">
    <v-main>
      <v-container fluid>  
        <v-card style="padding-left: 30px;" flat>
          <div class="label-style pt-1">
            <div class="label-width">Code:</div>  
            <div>{{ watp.watp_code }}</div>      
          </div>
          <div class="label-style">
            <div class="label-width">Language:</div>          
            <div>{{ watp.watp_taalcode }}</div>      
          </div>
          <div class="label-style" style="align-items: center" v-if="watp.watp_editable">
            <div class="label-width">Description:</div>          
            <div class="input-style"><v-text-field dense v-model="watp.watp_oms" label="" full-width></v-text-field></div>      
          </div>    
          <div v-else class="label-style">
            <div class="label-width">Description:</div>          
            <div>{{ watp.watp_oms }}</div>
          </div>
          <div class="label-style" style="align-items: center; margin-top: 30px; padding-bottom: 10px;">
            <div class="label-width">Template text</div>
            <v-btn class="primary" small @click="saveWatp(watp)" v-if="watp.watp_editable"><div class="px-2">Save</div></v-btn> 
          </div>
          <div style="border: solid 1px; border-color: lightgray;">
            <v-textarea v-model="watp.watp_text" :readonly="!watp.watp_editable" :counter="true" :value=watp.watp_text rows="10" style="padding: 5px 10px;"></v-textarea>  
            <div style="display: flex; flex-direction: row; justify-content: flex-end;" v-if="watp.watp_editable">
              <v-btn class="primary mx-2 mb-2" small @click="saveWatp(watp)"><div class="px-2">Save</div></v-btn>
            </div>
          </div>
        </v-card>  
      </v-container>
    </v-main>
    <navBar title="Ares - Template" :home="true" type=""/>    
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue"
 export default {
  components: {
    navBar,
  },
  props: ['watp_encrid'],
  data() {
    return {
      watp: {},
      dialog: false
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/watp/getWatp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getWatp"
          },
          getWatp: {
             watp_encrid: this.watp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.watp = res.data.getWatp;
            // console.log(this.watp)
          }
        })
    },
  methods: {
    saveWatp(watp) { 
      console.log(watp)
      this.$axios      
        .post("ares/json/ares/syst/watp/saveWatp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveWatp"
          },
          saveWatp: {
            watp: watp
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveWatp.text,
              color: res.data.saveWatp.color
            });
          }
        })
    },
  }  
};

</script> 
<style scoped>
.label-width {
  width: 150px;
}
.label-style {
  display: flex; 
  flex-direction: row; 
  font-size: large; 
  font-weight: 500;
}
.input-style {
  min-width: 600px; 
  width:fit-content;
}
</style>